module.exports = __webpack_public_path__ + "static/media/29EUNOG20.0acfaa32.jpg";